var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79916 0.484708C8.67533 0.360879 8.50173 0.283433 8.31323 0.283494C7.93687 0.283494 7.6261 0.59426 7.62623 0.970494L7.62623 7.79706L0.799665 7.79706C0.423304 7.79706 0.112538 8.10782 0.112666 8.48406C0.112666 8.66636 0.188794 8.8449 0.31388 8.96999C0.438965 9.09507 0.617187 9.17125 0.79981 9.1712L7.62637 9.1712L7.62638 15.9978C7.62638 16.1801 7.7025 16.3586 7.82759 16.4837C7.95054 16.6067 8.11913 16.685 8.31352 16.6849C8.68988 16.6849 9.00065 16.3741 9.00052 15.9979V9.17135L15.8271 9.17135C16.2034 9.17135 16.5142 8.86058 16.5141 8.48435C16.514 8.10811 16.2033 7.79722 15.8271 7.79735L9.00052 7.79735L9.00052 0.970782C9.00052 0.782598 8.92327 0.608815 8.7993 0.484852L8.79916 0.484708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.5393965de35ac3986b89f09af564b9ca.svg";
export { ForwardRef as ReactComponent };